import random from 'lodash/random';
import uniqueId from 'lodash/uniqueId';

import { ATG_PRODUCTS, SPORT_PRODUCTS } from 'shared/constants/AppConstants';

const getRandomDate = () =>
  new Date(Date.now() - Math.floor(Math.random() * 10000000000)).getTime();

const getRandomName = () => {
  const surNames = [
    'Berg',
    'Andersson',
    'Johansson',
    'Karlsson',
    'Nilsson',
    'Eriksson',
    'Larsson',
    'Olsson',
    'Persson',
    'Svensson',
    'Gustafsson',
    'Pettersson',
    'Jonsson',
    'Jansson',
    'Hansson',
    'Bengtsson',
    'Jönsson',
    'Lindberg',
    'Jakobsson',
    'Magnusson',
    'Olofsson',
    'Lindström',
    'Lindqvist',
    'Lindgren',
    'Axelsson',
  ];

  const names = [
    'Lars',
    'Mikael',
    'Anders',
    'Johan',
    'Erik',
    'Per',
    'Karl',
    'Peter',
    'Thomas',
    'Jan',
    'Daniel',
    'Fredrik',
    'Hans',
    'Andreas',
    'Stefan',
    'Mohamed',
    'Mats',
    'Marcus',
    'Mattias',
    'Magnus',
    'Bengt',
    'Jonas',
    'Oskar',
    'Alexander',
    'Niklas',
  ];

  return `${names[Math.floor(Math.random() * names.length)]} ${
    surNames[Math.floor(Math.random() * surNames.length)]
  }`;
};

export const menuItems = [
  'active',
  'completed',
  'leaders',
  'history',
  'million',
];

export const profitTypes = ['dividends', 'profits'];

export const getTopListKey = ({ month, year }) => `${year}-${month}`;

export const millionClubGames = Array.from({ length: 20 }).map(() => {
  // just for example, we will have hardcoded values here
  const product = Math.random() >= 0.5 ? 'atgProduct' : 'sportProduct';
  const events = [random(5, 25), random(5, 25)];
  const dividend = random(1000000, 32204004);
  const profit = Math.round(dividend / random(100, 1000));
  const stake = Math.round(random(1, 100));
  const productValues =
    product === 'atgProduct' ? ATG_PRODUCTS : SPORT_PRODUCTS;
  const productValue = productValues[random(0, productValues.length - 1)];
  const gameCodeId = product === 'atgProduct' ? 'atg' : 'sport';

  return {
    alias: getRandomName(),
    closeTime: getRandomDate(),
    completedEvents: Math.max(...events),
    date: getRandomDate(),
    dividend,
    errors: 0,
    events: Math.min(...events),
    gameCodeId,
    id: +uniqueId(),
    lockTime: getRandomDate(),
    stake,
    profit,
    resultsCompleteAt: getRandomDate(),
    product: productValue,
    [product]: productValue,
  };
});
